var _path, _circle, _rect, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpot({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4102 8.06467C11.8389 6.16761 13.5347 4.75098 15.5613 4.75098C17.9117 4.75098 19.8171 6.65636 19.8171 9.00677C19.8171 11.0777 18.3379 12.8032 16.3784 13.1842",
    stroke: "currentColor",
    strokeWidth: 1.38184
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.1643,
    cy: 14.2752,
    r: 5.87458,
    stroke: "currentColor",
    strokeWidth: 1.6
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 3.32988,
    height: 3.32988,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 10.1646 11.9199)",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.40755 8.56836L4.40755 4.65936L8.31397 4.65936",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinejoin: "bevel"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2404 16.3838L20.2404 20.2928L16.334 20.2928",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinejoin: "bevel"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpot);
export default __webpack_public_path__ + "static/media/spot.5c01c34583ff2025d3633d89c52e738e.svg";
export { ForwardRef as ReactComponent };